import { Product } from '@/models/Product';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<ProductAutocomplete>({})
export default class ProductAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Product' })
  protected label!: string;

  @Prop({ default: () => new Product() })
  protected model!: Product;

  @Prop({ default: 'Choose a product' })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected itemText(item: Product): string {
    return [
      item.product_id,
      item.type,
      item.name,
      item.brand ? item.brand.name : '',
      item.supplier_style_name,
    ]
      .filter(part => part)
      .join(' - ');
  }

  // #endregion

  // #region @Watchers
  // #endregion
}
